var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableCard',{attrs:{"height":"auto"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.desserts,"disable-sort":"","hide-default-footer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }